import { render, staticRenderFns } from "./WavegliderStatusWidget.vue?vue&type=template&id=53da6047&scoped=true"
import script from "./WavegliderStatusWidget.vue?vue&type=script&lang=js"
export * from "./WavegliderStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./WavegliderStatusWidget.vue?vue&type=style&index=0&id=53da6047&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53da6047",
  null
  
)

export default component.exports